<template>
  <div>
    <page-main
      :table-data="table"
      :params="params"
      :disabled="disabled"
      :loading="loading"
      :height="height"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
// import { getList } from '@api/projectManager/infoParticipant'
export default {
  components: {
    'PageMain': () => import('./components/main/index')
  },
  props: {
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    },
    autoLoad: {
      default: false,
      type: Boolean
    },
    height: {
      default: '',
      type: String || Number
    }
  },
  watch: {
    params: {
      handler () {
        if (this.autoLoad) {
          this.handleSubmit()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0
      }
    }
  },
  methods: {
    load () {
      this.handleSubmit()
    },
    // 加载表格数据
    handleSubmit (params) {
      this.loading = true
      this.$api.infoParticipantListApi({
        ...params || this.params,
        ...this.page
      }).then(res => {
        this.loading = false
        this.page.pageTotal = res.body.count
        this.table = res.body.data
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
